<template>
    <div class="chooseResult" v-show="breadcrumb_show">
      <dl>
        <dt>已选：</dt>
        <dd>
          <ul>
          
            <li v-if="value.provience && value.provience > 0">
                <a href="javascript:;" @click="deselect('provience')">
                {{ options.provience_options.find(o => o.provienceId === value.provience).provienceName }}
                </a>
            </li>
  
            <li v-if="value.city && value.city > 0" >
                <a href="javascript:;" @click="deselect('city')">
                {{ options.city_options.find(o => o.cityId === value.city).cityName }}
                </a>
            </li>


            <li v-if="value.manufacturer && value.manufacturer > 0">
                <a href="javascript:;" @click="deselect('manufacturer')">
                {{ options.manufacturer_options.find(o => o.manufacturerId === value.manufacturer).vehicleManufacturer }}
                </a>
            </li>

          </ul>
        </dd>
      </dl>
    </div>
  </template>
  
  <script>
  export default {
    name: "breadcrumb",
    props: {
      value: Object,
      options: Object,
      
    },
    data() {
      return {
        breadcrumb_show: false
      };
    },
    computed: {
        
    },
    watch: {
        value(new_val){
          let keys = Object.keys(new_val);
          for(let i = 0; i < keys.length; i++){
            if(new_val[keys[i]] > 1){
              this.breadcrumb_show = true;
              break;
            }
            this.breadcrumb_show = false;
          }
        },
    },
    mounted() {
    },
    methods: {
      deselect(condition_type){
          // console.log(this.options)
          this.$emit('deselect', condition_type); 
          this.$emit('filter');
          
      }
    },
  };
  </script>